import { useCallback, useMemo, useRef } from 'react';
// eslint-disable-next-line no-unused-vars
import { storageManager } from '../../utils/storageManager';
import { PerUserLocalStorageKey } from '../../utils/storageManager/const';
import { useUserPageContextState } from './UserContextProvider';

type SetStateAction<S> = S | ((prevState: S) => S);

export function useStoragePerUserData<Data>(key: string, defaultData?: Data) {
	const { id } = useUserPageContextState();
	const defaultDataRef = useRef<Data | undefined>(defaultData);
	const userStorageKey = `${PerUserLocalStorageKey}.${key}`;
	const hasUserId = typeof id !== 'undefined';

	const data = useMemo((): Data | null => {
		if (!hasUserId) {
			return null;
		}

		const dataFromStorage = storageManager.getSubItem<Data>(userStorageKey, String(id));

		if (
			(dataFromStorage === null || typeof dataFromStorage === 'undefined') &&
			typeof defaultDataRef.current !== 'undefined'
		) {
			return defaultDataRef.current!;
		}

		return dataFromStorage;
	}, [hasUserId, id, userStorageKey]);
	const setData = useCallback(
		(newData: SetStateAction<Data | null>): void => {
			if (typeof newData === 'function') {
				// @ts-ignore
				const result = newData(data);

				storageManager.setSubItem(userStorageKey, String(id), result);

				return;
			}

			storageManager.setSubItem(userStorageKey, String(id), newData);
		},
		[id, userStorageKey, data],
	);

	return {
		data,
		setData,
	};
}
